export const ListingBookViewingFormControlName = {
  Date: 'date',
  StartTime: 'startTime',
  Duration: 'duration',
  AdditionalDate: 'additionalDate',
  AdditionalStartTime: 'additionalStartTime',
  AdditionalDuration: 'additionalDuration',
  PhoneNumber: 'phoneNumber',
  ContactMethod: 'contactMethod',
};

export default {
  ListingBookViewingFormControlName,
};
